import { api } from '../utils/api';
import type { Supplier, SupplierCategory } from '../utils/mockDataSuppliers';

interface NeonSupplier {
  id:          string;
  name:        string;
  abn:         string | null;
  contactName: string | null;
  email:       string | null;
  phone:       string | null;
  address:     string | null;
  category:    string | null;
  isQualified: boolean;
  notes:       string | null;
  createdAt:   string;
  updatedAt:   string;
}

function mapNeonSupplier(s: NeonSupplier): Supplier {
  return {
    id:              s.id,
    companyName:     s.name,
    abn:             s.abn ?? '',
    contactName:     s.contactName ?? '',
    phone:           s.phone ?? '',
    email:           s.email ?? '',
    address:         s.address ?? '',
    website:         '',
    categories:      [(s.category ?? 'ELECTRICAL_SIGNALS') as SupplierCategory],
    status:          s.isQualified ? 'ACTIVE' : 'PENDING_APPROVAL',
    isPreferred:     s.isQualified,
    rating:          s.isQualified ? 4 : 3,
    paymentTermsDays: 30,
    distanceFromDepots: { BNE: 0, SC: 0 },
    notes:           s.notes ?? '',
    createdAt:       s.createdAt,
  } as unknown as Supplier;
}

export async function fetchSuppliers(): Promise<Supplier[]> {
  const { data } = await api.get<{ data: NeonSupplier[] } | NeonSupplier[]>('/api/suppliers');
  const raw: NeonSupplier[] = Array.isArray(data) ? data : ((data as any).data ?? []);
  return raw.map(mapNeonSupplier);
}

export async function createSupplier(payload: {
  companyName:  string;
  abn?:         string;
  contactName?: string;
  phone?:       string;
  email?:       string;
  address?:     string;
  category?:    string;
}): Promise<void> {
  try {
    await api.post('/api/suppliers', {
      name:        payload.companyName,
      abn:         payload.abn         ?? null,
      contactName: payload.contactName ?? null,
      phone:       payload.phone       ?? null,
      email:       payload.email       ?? null,
      address:     payload.address     ?? null,
      category:    payload.category    ?? null,
    });
  } catch (err) {
    console.warn('createSupplier to Neon failed:', err);
  }
}
